import React from "react";
import { Project } from "../../../types";
import { SpaceCategorySelector } from "../../Selectors/SpaceCategorySelector";

interface CategorySelectorFormItemProps {
  project: Project;
  disabled?: boolean;
  placeholder?: string;

  value?: string;
  onChange?: (value: any) => void;
}

export const CategorySelectorFormItem = (
  props: CategorySelectorFormItemProps,
) => (
  <SpaceCategorySelector
    selectedCategories={props.value != null ? [props.value] : []}
    project={props.project}
    disabled={props.disabled}
    placeholder={props.placeholder}
    onChange={(values) => {
      props.onChange?.(values[0]);
    }}
    allowCreatingNewValue
  />
);
